// 跳转微信小程序中转页
<template>
  <div></div>
</template>

<script>
import { generateMiniSchema } from '@/api/distributor';

export default {
  components: {
  },
  data() {
    return {
    };
  },
  created() {
    this.redirect();
  },
  methods: {
    async redirect() {
      let { query } = this.$route;
      let res = await generateMiniSchema({
          jump: {
            path: query.path,
            query: query.query,
            envVersion: 'release',
          },
        })
        if (res.data) {
          window.location.href = res.data;
        }
    }
  },

}

</script>

<style lang='scss' scoped>

</style>
